import React, {
  useRef,
  useState
} from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import {
  Avatar,
  Box,
  ButtonBase,
  Hidden,
  Menu,
  MenuItem,
  Typography
} from '@mui/material';
import {  makeStyles } from '@mui/styles';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';


import { signout } from 'src/actions/accountActions';


const useStyles = makeStyles((theme) => ({
  avatar: {
    height: 32,
    width: 32,
    marginRight: theme.spacing(1)
  },
  popover: {
    width: 200
  }
}));

function Account() {
  const classes = useStyles();
  const navigate = useNavigate();
  const ref = useRef(null);
  const dispatch = useDispatch();
  const account = useSelector((state) => state.account);
  const { enqueueSnackbar } = useSnackbar();
  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSignout = async () => {
    try {
      handleClose();
      await dispatch(signout());
      navigate('/');
    } catch (error) {
      enqueueSnackbar('Unable to signout', {
        variant: 'error'
      });
    }
  };

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        component={ButtonBase}
        onClick={handleOpen}
        ref={ref}
      >

        <AccountCircleIcon fontSize="large" color="contrastText" />
        <Hidden smDown>
          <Typography
            variant="h6"
            color="inherit"
          >
            {`${account.user.name}`}
          </Typography>
        </Hidden>
      </Box>
      <Menu
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        keepMounted
        PaperProps={{ className: classes.popover }}
        getContentAnchorEl={null}
        anchorEl={ref.current}
        open={isOpen}
      >
        <MenuItem
          component={RouterLink}
          to="/app/account"
        >
          Account
        </MenuItem>
        <MenuItem
          component={RouterLink}
          to="/app/management/admin/change/password"
        >
          Change password
        </MenuItem>
        {/* <MenuItem
          component={RouterLink}
          to="/app/management/admin/renew/password"
        >
          Renew password
        </MenuItem> */}
        <MenuItem onClick={handleSignout}>
          Sign Out
        </MenuItem>
      </Menu>
    </>
  );
}

export default Account;
